<template>
  <div class="good-info-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="top">
          <div class="left">
            编辑成分
            <div class="add-btn" @click="handleModal('add')">+ 添加成分</div>
          </div>
          <div class="right">
            选择营养成分明含量表表头
            <div class="unit-list">
              <div
                class="unit-item"
                v-for="(unit, unitIndex) in unitList"
                :key="unitIndex"
                @click="unit.checked = !unit.checked"
              >
                <div class="round" :class="{ active: unit.checked }"></div>
                {{ unit.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="list">
          <div
            class="item"
            v-for="(item, index) in ingredientTable"
            :key="index"
          >
            <table>
              <tr v-for="(rowItem, rowIndex) in item" :key="rowIndex">
                <td v-for="(colItem, colIndex) in rowItem" :key="colIndex">
                  <span v-if="rowIndex === 0 || colIndex === 0">{{
                    colItem
                  }}</span>
                  <el-input
                    v-model="rowItem[colIndex]"
                    v-else
                    :key="timeStamp"
                    size="mini"
                    class="input"
                  ></el-input>
                </td>
              </tr>
            </table>

            <div class="table-btn">
              <div class="btn" @click="handleModal('edit', item, index)">
                编辑成分项
              </div>
              <div class="btn btn2" @click="deleteItem(index)">
                删除成分项
              </div>
            </div>
          </div>
        </div>
        <div class="btn-box">
          <button class="cancel-btn" @click="handleCancel">取消</button>
          <button class="confirm-btn" @click="handleConfirm">保存</button>
        </div>
      </div>
    </div>
    <el-dialog
      :title="(type === 'add' ? '添加' : '编辑') + '成分项'"
      width="480px"
      :visible.sync="addVisible"
    >
      <div :key="timeStamp">
        <div class="title-box">
          <div class="label">成分标题</div>
          <el-input
            v-model="componentTitle"
            size="small"
            class="input"
          ></el-input>
        </div>
        <el-table
          :data="ingredient"
          class="order-table table no-border-table"
          ref="labelTable"
          height="400"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="labelName"
            align="center"
            label="选项名称"
          ></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="addVisible = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="handleAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: { Header },
  name: 'goods-lock',
  data() {
    return {
      loading: 0,
      title: {
        // 页面标题
        firstTitile: '产品管理',
        secondTitle: '编辑成分'
      },
      id: null,
      baseInfo: {
        name: '',
        brand: null,
        series: null,
        masterPic: '',
        price: null,
        status: null,

        milkVersion: null,  // 奶粉版本
        milkSource: null, // 奶源地
        milkOrigin: null, // 产地
        milkCategory: null, // 类别
        milkSpecification: null,  //规格
        milkRecommendedAge: null, //适用年龄

        ingredientList: '', // 配料表
        milkReview: '', // 奶粉点评
        sourceReview: '',// 奶源点评
        materialReview: '',// 原料点评
        milkStage: '', //段位

        manufacturer: '', // 厂家
        regNo: '', // 注册号
        serviceProvider: '', // 运营商

        advantage: '',
        nutritionalAnalysisNormal: '',
        nutritionalAnalysisFortify: '',

        ingredientTable: [],
        summary: '',
        customFields: [],
        alias: []
      },
      multipleSelection: [],
      list: [],
      addVisible: false,
      timeStamp: +new Date(),
      ingredient: [],
      ingredientSortMap: {},
      type: '',
      tableIndex: null,
      rowMap: {},
      unitList: [
        {
          name: '每100g',
          checked: false,
        },
        {
          name: '每100kj',
          checked: false,
        },
        {
          name: '每100ml',
          checked: false,
        }
      ],
      componentTitle: '',
      ingredientTable: []
    };
  },
  computed: {},
  async mounted() {
    await this.getLabelItem();
    let query = this.$route.query;
    if (query && query.id) {
      this.id = query.id;
      this.getGoodDetail(query.id);
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取产品信息
    getGoodDetail(id) {
      this.loading++;
      this.httpGet(this.$root.getGoodInfo, { id }).then(
        (res) => {
          this.loading--;
          let baseInfo = { ...this.baseInfo };
          for (let key in baseInfo) {
            baseInfo[key] = res[key];
          }
          this.baseInfo = { ...baseInfo };
          this.id = res.id;
          let arr = res.ingredientUnit.split(',');
          this.unitList.forEach((item, index) => {
            item.checked = Boolean(+arr[index]);
          });
          let list = [];
          // console.log(res.ingredientTable);
          res.ingredientTable.forEach((item, index) => {
            list[index] = [];
            let obj = {};
            item[0].forEach((col, colIndex) => {
              if(colIndex >= 2){
                obj[col] = colIndex;
              }
            });
            item.forEach((row, rowIndex) => {
              list[index][rowIndex] = [];
              if(rowIndex === 0){
                row.forEach((col, colIndex) => {
                  if(colIndex < 2){
                    list[index][rowIndex][colIndex] = col;
                  }
                });
                list[index][rowIndex].push("每100g");
                list[index][rowIndex].push("每100kj");
                list[index][rowIndex].push("每100ml");
              } else {
                row.forEach((col, colIndex) => {
                  if(colIndex < 2){
                    list[index][rowIndex][colIndex] = col;
                  }
                });
                list[index][rowIndex].push(row[obj["每100g"]] || '');
                list[index][rowIndex].push(row[obj["每100kj"]] || '');
                list[index][rowIndex].push(row[obj["每100ml"]] || '');
              }
            })
          })
          // console.log(list);
          this.ingredientTable = list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    async getLabelItem(){
      await this.getLabelItemByName('ingredient');
    },
    getLabelItemByName(dataName){
      this.loading++;
      return this.httpGet(this.$root.getLabelItem, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res;
          let sortMap = {};
          res.forEach(item => {
            sortMap[item.labelName] = item.detailSort;
          });
          this[dataName + 'SortMap'] = sortMap;

        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    handleModal(type, item, index){
      this.type = type;
      this.tableIndex = index;
      this.timeStamp = +new Date();
      this.addVisible = true;
      this.rowMap = {};
      if(this.type === 'edit'){
          this.componentTitle = item[0][0];
          this.$nextTick(() => {
          this.$refs.labelTable.clearSelection();
          item.forEach((item, itemIndex) => {
            if(itemIndex > 0){
              this.rowMap[item[0]] = item;
              let find = this.ingredient.find(i => i.labelName === item[0]);
              find && this.$refs.labelTable.toggleRowSelection(find, true);
            }
          });
        })
      }
    },
    deleteItem(index){
      this.ingredientTable.splice(index, 1);
    },
    handleAdd(){
      this.intensifySelected = this.multipleSelection;
      if(!this.componentTitle){
        this.$message.error('请填写成分标题');
        return;
      }
      // this.addVisible = false;
      if(this.type === 'add'){
        // console.log(this.multipleSelection);
        let arr = [];
        this.multipleSelection.forEach(item => {
          arr.push([item.labelName, '', '', '', '']);
        });

        //排序
        arr.sort((a, b) => {
          return this.ingredientSortMap[b[0]] - this.ingredientSortMap[a[0]];
        });


        this.ingredientTable.push(
          [
            [this.componentTitle, '单位', '每100g', '每100kj', '每100ml'],
            ...arr
          ]
        );
      }
      if(this.type === 'edit'){
        let arr = [];
        this.multipleSelection.forEach(item => {
          if(this.rowMap[item.labelName]){
            arr.push(this.rowMap[item.labelName]);
          } else {
            arr.push([item.labelName, '', '', '', '']);
          }
        });


        //排序
        arr.sort((a, b) => {
          return this.ingredientSortMap[b[0]] - this.ingredientSortMap[a[0]];
        });

        this.ingredientTable[this.tableIndex] = [
          [this.componentTitle, '单位', '每100g', '每100kj', '每100ml'],
          ...arr
        ];
        // this.ingredientTable[this.tableIndex] = [...this.ingredientTable[this.tableIndex]];
        this.ingredientTable = [...this.ingredientTable];
        this.timeStamp = +new Date();
        // console.log(this.ingredientTable);
      }
      this.addVisible = false;
    },
    // 取消
    handleCancel() {
      this.$router.push({ name: 'goodsManage' });
    },
    handleConfirm(){
      // console.log(this.ingredientTable);
      // console.log(this.unitList.map(item => +item.checked));
      // return;
      this.loading++;
      this.httpPut(this.$root.updateGood, {
        id: this.id,
        ...this.baseInfo,
        ingredientUnit: this.unitList.map(item => +item.checked).join(','),
        ingredientTable: this.ingredientTable
      }).then(
        (res) => {
          this.$message({
            message: '产品成分修改成功',
            type: 'success'
          });
          this.loading--;
          this.$router.push({
            name: 'goodsManage'
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.good-info-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      // background: white;
      box-sizing: border-box;
      padding: 0 20px 24px;
      border-radius: 2px;

      .top{
        width: 100%;
        height: 64px;
        word(20px, #333);
        background: #fff;
        border-radius: 5px;
        padding: 0 24px;
        box-sizing: border-box;
        flex-x();

        .left, .right{
          flex-x(flex-start);
        }

        .right{
          word(14px, #333);
          .unit-list{
            margin-left: 20px;
            flex-x();
            .unit-item{
              flex-x();
              margin-right: 12px;
              .round{
                width: 20px;
                height: 20px;
                border-radius: 10px;
                margin-right: 8px;
                cursor: pointer;
                background: #ccc;
                &.active{
                  background: #5283FF;
                }
              }
            }
          }
        }

        .add-btn{
          width: 120px;
          height: 32px;
          border-radius: 5px;
          background: #5283FF;
          word(14px, #fff);
          flex-x(center);
          cursor: pointer;
          margin-left: 20px;
        }
      }

      .list{
        flex-x(flex-start);
        flex-wrap: wrap;
        margin: 10px 0;
        .item{
          background: #fff;
          padding: 16px;
          border-radius: 5px;
          margin-right: 10px;
          margin-bottom: 10px;
          table{
            tr{
              height: 32px;
              line-height: 32px;
              td{
                width: 85px;
                text-align: center;
                line-height: 32px;
                box-sizing: border-box;
                &:nth-of-type(1){
                  width: 110px;
                }
                .input{
                  width: 100%;
                  text-align: center;
                  >>>.el-input__inner{
                    border-width: 0;
                    text-align: center;
                  }
                }
              }
            }
            tr:nth-of-type(1){
              background: #E3E3E3;
            }
            tr:nth-of-type(n+1){
              td{
                border-right: 1px solid #E3E3E3;
                border-bottom: 1px solid #E3E3E3;
              }
              td:nth-of-type(1){
                border-left: 1px solid #E3E3E3;
              }
            }
          }
          .table-btn{
            flex-x();
            margin-top: 10px;
            .btn{
              width: 100px;
              height: 32px;
              border-radius: 5px;
              background: #E0E9FF;
              word(14px, #5283FF);
              flex-x(center);
              cursor: pointer;
            }
            .btn2{
              background: #5283FF;
              word(14px, #fff);
            }
          }
        }
      }

      .group {
        background: white;
        padding: 10px 0;
        margin-bottom: 10px;
        .basic {
          height: 48px;
          line-height: 48px;
          font-size: 20px;
          text-indent: 20px;
          // margin-top: 20px;
          color: gray3;
          flex-x(flex-start);

          span {
            // color: red;
            color: gray6;
            margin-right: 3px;
          }
        }
      }

      .base-info {
        // margin-bottom: 10px;
        background: white;

        .good-form {
          padding: 20px 0 30px;

          .img-box {
            flex-x(flex-start);
          }
        }


        .add-category{
          // width: 80px;
          cursor: pointer;
          color: #5283FF;
          flex-x(flex-start);
          flex-shrink: 0;
        }

        .base-info-form {
          margin-left: 90px;
        }

        .good-input {
          width: 620px;
        }

        .tip {
          font-size: 14px;
          color: gray6;
          margin-left: 16px;
        }

        .red {
          color: red;
        }

        .row{
          flex-x(flex-start);
          .item{
            height: 66px;
            flex-x(flex-start);
            .label{
              width: 200px;
              margin-right: 36px;
              text-align: right;
            }
          }
        }
      }
    }
  }

  .btn-box {
    background: white;
    width: 100%;
    flex-x(center);
    height: 100px !important;
    flex-shrink: 0;
    // padding-bottom: 48px;

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }
  .title-box{
    flex-x(flex-start);
    height: 50px;
    background: white;
    wrod(14px, #333);
    .input{
      width: 200px;
      margin-left: 10px;
    }
  }
}
</style>
